import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DialogModule } from 'primeng/dialog';
import { ButtonModule } from 'primeng/button';
import { Plan } from '../../shared/models/plan.model';

@Component({
  selector: 'app-plan-change-confirmation',
  standalone: true,
  imports: [CommonModule, DialogModule, ButtonModule],
  templateUrl: './plan-change-confirmation.component.html',
  styleUrls: ['./plan-change-confirmation.component.scss']
})
export class PlanChangeConfirmationComponent {
  @Input() visible: boolean = false;
  @Input() currentPlan: Plan | null = null;
  @Input() newPlan: Plan | null = null;
  @Input() loading: boolean = false;
  @Output() visibleChange = new EventEmitter<boolean>();
  @Output() confirmChange = new EventEmitter<Plan>();

  hideDialog() {
    if (this.loading) return; // Prevent closing while loading
    this.visible = false;
    this.visibleChange.emit(false);
  }

  onConfirm() {
    if (this.newPlan && !this.loading) {
      this.confirmChange.emit(this.newPlan);
    }
  }

  getCurrentPlanPrice(): string {
    if (!this.currentPlan) return 'N/A';
    const monthlyPrice = this.currentPlan.interval === 'year' 
      ? this.currentPlan.amount / 12 
      : this.currentPlan.amount;
    return `${this.currentPlan.currency}${monthlyPrice}`;
  }

  getNewPlanPrice(): string {
    if (!this.newPlan) return 'N/A';
    const monthlyPrice = this.newPlan.interval === 'year' 
      ? this.newPlan.amount / 12 
      : this.newPlan.amount;
    return `${this.newPlan.currency}${monthlyPrice}`;
  }

  getCurrentPlanInterval(): string {
    if (!this.currentPlan) return '';
    return this.currentPlan.interval === 'year' ? 'Yearly' : 'Monthly';
  }

  getNewPlanInterval(): string {
    if (!this.newPlan) return '';
    return this.newPlan.interval === 'year' ? 'Yearly' : 'Monthly';
  }
} 